// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b3c01ea7","container":"ae5c0bee","uploadButton":"c538e6ab","imageContainer":"f4ffa67a","image":"edfe043a","input":"d418909b","cancel":"d1b8db23"};